import { render, staticRenderFns } from "./EditTaskModal.vue?vue&type=template&id=2e76eadc&"
import script from "./EditTaskModal.vue?vue&type=script&lang=ts&"
export * from "./EditTaskModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports